'use client';
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["as", "classPrefix", "className", "locale"];
import React from 'react';
import Close from '@rsuite/icons/Close';
import { useClassNames, useCustom } from "../hooks/index.js";
/**
 * Close button for components such as Message and Notification.
 */
var CloseButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$as = props.as,
    Component = _props$as === void 0 ? 'button' : _props$as,
    _props$classPrefix = props.classPrefix,
    classPrefix = _props$classPrefix === void 0 ? 'btn-close' : _props$classPrefix,
    className = props.className,
    overrideLocale = props.locale,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var _useClassNames = useClassNames(classPrefix),
    withClassPrefix = _useClassNames.withClassPrefix,
    merge = _useClassNames.merge;
  var _useCustom = useCustom('CloseButton', overrideLocale),
    locale = _useCustom.locale;
  var classes = merge(className, withClassPrefix());
  return /*#__PURE__*/React.createElement(Component, _extends({
    type: "button",
    ref: ref,
    className: classes,
    "aria-label": locale === null || locale === void 0 ? void 0 : locale.closeLabel
  }, rest), /*#__PURE__*/React.createElement(Close, null));
});
CloseButton.displayName = 'CloseButton';
export default CloseButton;